import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'

import ClassCoursePage from 'app/pages/Class/Course'
import ClassStandardPage from 'app/pages/Class/Standard'
import ClassSubjectCategoryPage from 'app/pages/Class/SubjectCategory'
import SubjectsPage from 'app/pages/Subjects'

/**
 * Unified Programs page — matches the pattern already used by Memberships /
 * Subjects / Orders / Users / Sessions / Enrolments: one sidebar entry,
 * internal tabs, every legacy path under /programs/* still routes here
 * (the extra paths are registered as sideBarVisibility:false in
 * navigationMenus).
 *
 * Tabs:
 *   · Categories  → ClassSubjectCategoryPage  (/programs/subject-categories)
 *   · Subjects    → SubjectsPage              (/programs/subjects + /…/playdate + /…/toddler-club)
 *   · Standards   → ClassStandardPage         (/programs/standards)
 *   · Courses     → ClassCoursePage           (/programs/courses)
 *
 * The Subjects tab keeps its own internal Regular/Playdate/Toddler Club
 * sub-tabs (handled inside SubjectsPage by reading the same pathname).
 */

const TAB_DEFS = [
  {
    key: 'categories',
    label: 'Categories',
    path: navigationPaths.subjectCategory,
    Component: ClassSubjectCategoryPage,
    matches: (pathname) => pathname === navigationPaths.subjectCategory
  },
  {
    key: 'subjects',
    label: 'Subjects',
    // Active tab for the bare /programs/subjects route AND for the playdate
    // / toddler-club sub-routes — SubjectsPage owns the inner tab switch.
    path: navigationPaths.subject,
    Component: SubjectsPage,
    matches: (pathname) => pathname.startsWith(navigationPaths.subject)
  },
  {
    key: 'standards',
    label: 'Standards',
    path: navigationPaths.standard,
    Component: ClassStandardPage,
    matches: (pathname) => pathname === navigationPaths.standard
  },
  {
    key: 'courses',
    label: 'Courses',
    path: navigationPaths.course,
    Component: ClassCoursePage,
    matches: (pathname) => pathname === navigationPaths.course
  }
]

const Programs = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const activeTab =
    TAB_DEFS.find((t) => t.matches(pathname))?.key ?? TAB_DEFS[0].key

  const handleTabChange = (_, value) => {
    if (value === activeTab) return
    const def = TAB_DEFS.find((t) => t.key === value)
    if (def) history.push(def.path)
  }

  const ActiveComponent =
    TAB_DEFS.find((t) => t.key === activeTab)?.Component ?? TAB_DEFS[0].Component

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {TAB_DEFS.map((t) => (
            <Tab key={t.key} label={t.label} value={t.key} />
          ))}
        </Tabs>
      </PageTabsBar>
      <ActiveComponent />
    </>
  )
}

export default Programs
